import { IReactiveNewsContentItem } from "../SchoolFeedContentItem";
import FontAwesome from "../../utilities/FontAwesome";
import WatsonApi from "../../../backends/WatsonApi";
import styles from "./styles/ListItemGroup.module.scss";
import { useState } from "react";
import { useStores } from "../../../stores/useStores";

export function TranslateButton(props: { itemObj: IReactiveNewsContentItem }) {
  const { i18nStore } = useStores();
  const [translating, setTranslating] = useState(false);

  // 1. If shouldChangeGoogleTranslate is true, the item has already been translated, so we shouldn't show the button.
  // 2. If the item's language doesn't match the language the page is being viewed in, show the translate button.
  const shouldDisplayTranslateButton =
    !i18nStore.shouldChangeGoogleTranslate &&
    props.itemObj.language !== i18nStore.currentOrgSupportedLocale;

  if (shouldDisplayTranslateButton) {
    return (
      <div className={styles.translateButton}>
        <button
          onClick={async (e) => {
            e.stopPropagation();

            setTranslating(true);
            const client = await WatsonApi();
            const response =
              await client.apis.organizations.organizations_content_items_translated(
                {
                  organization_pk: props.itemObj.organization_id,
                  id: props.itemObj.id,
                  expand: "discussion_prompt",
                },
              );
            const contentItem = JSON.parse(response.data);
            props.itemObj.update({
              description: contentItem.description,
              title: contentItem.title,
              language: i18nStore.currentOrgSupportedLocale,
              discussion_prompt:
                contentItem.discussion_prompt ||
                props.itemObj.discussion_prompt,
              translated: true,
            });
            setTranslating(false);
          }}
        >
          <FontAwesome
            prefix={"fas"}
            name={"fa-arrows-rotate"}
            spin={translating}
          />{" "}
          Translate
        </button>
      </div>
    );
  } else {
    return <></>;
  }
}
